import { GridRenderCellParams } from '@mui/x-data-grid';

import { useFormatAmount, UseFormatNumberProps } from '../../../../hooks/useNumberFormat';
import FallbackCell, { FallbackCellProps } from '../FallbackCell';

export interface AmountCellProps extends Omit<FallbackCellProps<number>, 'children'> {
  formatProps?: Omit<UseFormatNumberProps, 'locale'>;
}

export default function AmountCell({ formatProps = {}, ...props }: AmountCellProps) {
  const formatAmount = useFormatAmount(formatProps);

  return <FallbackCell<number> {...props}>{formatAmount}</FallbackCell>;
}

export function renderAmountCell({ value }: GridRenderCellParams) {
  return <AmountCell value={value} formatProps={{ style: 'currency', currency: 'USD', currencyDisplay: 'symbol' }} />;
}

export function renderNumberCell({ value }: GridRenderCellParams) {
  return <AmountCell value={value} formatProps={{}} />;
}
